import { generateRandomId } from '../generateRandomId';
import type { PriceComparePort } from '../types/PriceComparePort';

export const createPriceComparePort = (portId?: string): PriceComparePort => ({
    id: generateRandomId(),
    portId,
});
